export default __webpack_public_path__ + "media/images/wiki_128-e16ee7b491c5141344a4e7ce3296f074.png";